export const environment = {
  production: true,
  buildId: '3839987194023551',
  configFile: 'config.json',
};
